import { TimelineData } from "../Timeline/Types";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { GAME_GENERAL_STATE, useGameGeneralState } from "./useGameGeneralState";

export const useTimelineHeader = (timeline: TimelineData) => {
    const [clock, setClock] = useState<string>();
    const gameState = useGameGeneralState(timeline);

    useEffect(() => {
        let parsedTime = "";
        let parsedStoppageTime = "";
        switch (gameState) {
            case GAME_GENERAL_STATE.NOT_STARTED:
                parsedTime = `${dayjs(timeline.sportEvent.startTime).format(
                    "HH:mm",
                )}`;
                break;
            case GAME_GENERAL_STATE.HALFTIME:
                parsedTime = "Halbzeit";
                break;
            case GAME_GENERAL_STATE.CLOSED:
            case GAME_GENERAL_STATE.ENDED:
                parsedTime = "Abpfiff";
                break;
            case GAME_GENERAL_STATE.CANCELLED:
                parsedTime = "Spiel abgebrochen";
                break;
            case GAME_GENERAL_STATE.INTERRUPTED:
                parsedTime = "Verbindung wird hergestellt";
                break;
            case GAME_GENERAL_STATE.INTERRUPTED_NO_UPDATES:
                parsedTime = "Spiel unterbrochen";
                break;
            default:
                parsedTime =
                    timeline.sportEventStatus.clock?.clockTimePlayed?.split(
                        ":",
                    )[0] ?? "";
                if (!parsedTime.length) {
                    break;
                }
                parsedStoppageTime =
                    timeline.sportEventStatus.clock?.stoppageTimePlayed?.split(
                        ":",
                    )[0] ?? "";

                if (parsedTime !== "90" && parsedTime !== "45") {
                    parsedTime = (parseInt(parsedTime) + 1).toString();
                }

                if (parsedStoppageTime !== "") {
                    parsedTime +=
                        "+" + (parseInt(parsedStoppageTime) + 1).toString();
                }

                parsedTime += "'";
        }
        setClock(parsedTime);
    }, [timeline, gameState]);

    return clock;
};
